module.exports = __webpack_public_path__ + "static/media/EDAConcept.3ea2270c.svg";